import "./CoreServices.module.css";
import Header from "@/reusable_sections/Header";
import OurClinicalExpertise from "./sections/OurClinicalExpertise";
import SafetyInEveryMile from "./sections/SafetyInEveryMile";
import ReadyToPostYourFirstRole from "./sections/ReadyToPostYourFirstRole";
import Footer from "@/reusable_sections/Footer";
export default function CoreServicesPage() {
  return <div>
      <Header />
      <OurClinicalExpertise />
      <SafetyInEveryMile />
      <ReadyToPostYourFirstRole />
      <Footer />
    </div>;
}